/** Справочник городов с публичными страницами афиши /afisha/<slug>. */
export type AfishaCity = {
  /** Слаг в URL: /afisha/antalya */
  slug: string;
  /** Именительный падеж: «Анталья» */
  name: string;
  /** Родительный падеж для H1: «Афиша Антальи» */
  genitive: string;
  /** Предложный падеж: «в Анталье» */
  prepositional: string;
  /** Значение поля city в базе */
  city: string;
};

export const AFISHA_CITIES: AfishaCity[] = [
  { slug: "antalya", name: "Анталья", genitive: "Антальи", prepositional: "в Анталье", city: "Анталья" },
  { slug: "stambul", name: "Стамбул", genitive: "Стамбула", prepositional: "в Стамбуле", city: "Стамбул" },
  { slug: "ankara", name: "Анкара", genitive: "Анкары", prepositional: "в Анкаре", city: "Анкара" },
];

export function afishaCityBySlug(slug: string | null | undefined): AfishaCity | null {
  return AFISHA_CITIES.find((c) => c.slug === slug) ?? null;
}
